import PropTypes from 'prop-types';
import React from 'react';
import { Button, XClose } from '@opendate-app/setlist';
import { CONDUCTOR_WIDGET_HINT } from '../useConductorWidgetHint';

const ConductorWidgetHint = ({ onDismiss }) => (
  <span className="conductor-widget-hint">
    {CONDUCTOR_WIDGET_HINT}
    <Button
      variant="tertiary"
      size="sm"
      icon={XClose}
      className="conductor-widget-hint-dismiss"
      aria-label="Dismiss hint"
      data-testid="conductor-widget-hint-dismiss"
      onClick={onDismiss}
    />
  </span>
);

ConductorWidgetHint.propTypes = {
  onDismiss: PropTypes.func.isRequired
};

export default ConductorWidgetHint;
